import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSearch,
  faAngleRight,
  faAngleLeft,
  faAngleUp,
  faAngleDown,
  faMinusSquare,
  faPlusSquare,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faFileAlt,
  faTimes,
  faArrowUp,
  faArrowDown,
  faPlus,
  faMinus,
  faTrash,
  faDesktop,
  faColumns,
  faImage,
  faCode,
  faEye,
  faPaperPlane,
  faCheck,
  faShoppingCart,
  faDownload,
  faEyeSlash,
  faTags,
  faCaretDown,
  faCaretUp,
  faImages,
  faAlignLeft,
  faObjectGroup,
  faQuestion,
  faQuestionCircle,
  faExternalLinkAlt,
  faUndo,
  faRedo,
  faBars,
  faSave,
  faBold,
  faCompress,
  faExpand,
  faStrikethrough,
  faUnderline,
  faSubscript,
  faSuperscript,
  faTag,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  install(Vue, options = {}) {
    library.add(
      faSearch,
      faAngleRight,
      faAngleLeft,
      faAngleUp,
      faAngleDown,
      faMinusSquare,
      faPlusSquare,
      faChevronLeft,
      faChevronRight,
      faChevronUp,
      faChevronDown,
      faFileAlt,
      faTimes,
      faArrowUp,
      faCompress,
      faExpand,
      faArrowDown,
      faPlus,
      faMinus,
      faTrash,
      faDesktop,
      faColumns,
      faImage,
      faCode,
      faEye,
      faPaperPlane,
      faCheck,
      faShoppingCart,
      faDownload,
      faEyeSlash,
      faTags,
      faCaretDown,
      faCaretUp,
      faAlignLeft,
      faImages,
      faObjectGroup,
      faQuestion,
      faQuestionCircle,
      faExternalLinkAlt,
      faUndo,
      faRedo,
      faBars,
      faSave,
      faBold,
      faStrikethrough,
      faUnderline,
      faSubscript,
      faSuperscript,
      faTag
    );

    Vue.component("font-awesome-icon", FontAwesomeIcon);
  },
};
